import { ReactNode } from 'react';
import FakeScreen from '../FakeScreen';

export interface iErrorImage {
  children: ReactNode;
}

function ErrorImage({ children }: iErrorImage) {
  return (
    <div className="flex justify-center max-w-[480px] w-full my-8 xs:my-16">
      <div className="flex-grow"></div>
      <FakeScreen>{children}</FakeScreen>
      <div className="flex-grow"></div>
    </div>
  );
}

export default ErrorImage;
